import {
  chakra,
  forwardRef,
  type TableFooterProps as ChakraTfootProps,
} from '@chakra-ui/react-v2';
import { cx } from '@chakra-ui/utils';

import { useTableStyles } from '../TableStylesContext';
import { getClassName } from './className';

export type TfootProps = ChakraTfootProps;

export const Tfoot = forwardRef<TfootProps, 'tfoot'>(
  ({ className, ...props }, ref) => {
    const { tfoot: tfootStyles } = useTableStyles() ?? {};

    return (
      <chakra.tfoot
        className={cx(getClassName('tfoot'), className)}
        {...props}
        ref={ref}
        __css={tfootStyles}
      />
    );
  },
);
